export const REPORT_UUID_FIELDS = new Set([
  'template_id',
  'signature_id',
  'location_id',
  'folder_id',
  'parent_report_id',
  'revoked_by',
]);

export function normalizeReportPayload(value) {
  if (Array.isArray(value)) return value.map(normalizeReportPayload);
  if (!value || typeof value !== 'object') return value;

  return Object.fromEntries(
    Object.entries(value).map(([key, fieldValue]) => [
      key,
      REPORT_UUID_FIELDS.has(key) && fieldValue === ''
        ? null
        : normalizeReportPayload(fieldValue),
    ])
  );
}

export function reportAssetUrl(report, kind) {
  if (!report?.id || !report?.access_token) return null;
  if (!['location', 'signature'].includes(kind)) return null;

  const params = new URLSearchParams({
    report_id: String(report.id),
    kind,
    token: String(report.access_token).trim().toUpperCase(),
  });

  return `/.netlify/functions/report-asset?${params.toString()}`;
}

export function areReportAssetsReady(report, state = {}) {
  const expectedImages = Array.isArray(report?.images) ? report.images.length : 0;
  const imagesReady = Number(state.imagesLoaded || 0) >= expectedImages;
  const logoReady = !report?.location_logo_url || state.logoLoaded === true;
  const signatureReady = !report?.signature_image_url || state.signatureLoaded === true;

  return imagesReady && logoReady && signatureReady;
}
